import React from 'react';

import { ListItem } from '../ListItem';

import styles from './styles/list.module.scss';

export const List = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items?.map((item) => (
        <li key={item.id}>
          <ListItem item={item} />
        </li>
      ))}
    </ul>
  );
};
